import { MouseEvent } from 'react';
import { IconName } from '@optimus-web/icons';
import { Icon } from '../Icon';
import { Activable } from '../types';
import { ImageAmountTextElement, ImageAmountWrapperElement } from './style';

export interface ImageAmountProps extends Activable {
    amount: number;
    onClick?: (event: MouseEvent<HTMLDivElement>) => void;
}

const ImageAmount = ({ amount, active, ...other }: ImageAmountProps) => (
    <ImageAmountWrapperElement active={active} {...other}>
        <Icon value={IconName.Camera} variant="primary" />
        <ImageAmountTextElement>{amount}</ImageAmountTextElement>
    </ImageAmountWrapperElement>
);

export default ImageAmount;
